import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen flex flex-col border-t-[8px] border-ink" data-id="element-1">
        <Nav data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
          </Routes>
        </main>
        <Footer data-id="element-9" />
      </div>
    </BrowserRouter>;
}